<script setup>
import { RouterView } from 'vue-router'
import Toast from '@components/ui/Toast.vue'
</script>

<template>
  <div id="app-container">
    <RouterView />
    <Toast />
  </div>
</template>

<style scoped>
#app-container {
  min-height: 100vh;
}
</style>
